import React from 'react';
import { IconProps } from '.';

const SvgDotsVertical = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M10.5 19a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0ZM12 6.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3ZM12 13.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z'
      />
    </svg>
  );
};

export default SvgDotsVertical;
